export default {
  business: (state: any) => state.business ?? {},
  businessId: (state: any) => state.business?.user_id ?? '',
  feedbackId: (state: any) => state.business.feedback_id,
  businessName: (state: any) => state.business?.business_name,
  businessCountry: (state: any) => state.business?.business?.country ?? state.business?.country_code ?? 'KW',
  businessType: (state: any) => state.business?.business_type,
  countryIcon: (state: any) => state.business?.country_icon,
  fees: (state: any) => state.business.fees,
  phone: (state: any) => state.business.phone,
  removePowerBy: (state: any) => state.business.remove_power_by ?? false,
  location: (state: any) => state.business.location,
  browserLanguage: (state: any) => state.business?.browser_lang_webapp,
  locales: ({ business }: any) => (business.locales?.length && business.locales[0] !== '' ? business.locales : ['en']),
  showReserve: (state: any) => state.showReserve,
  socialLinks: (state: any) => state.business.social_links,
  feedback: (state: any) => state.business.feedback,
  newsletter: (state: any) => state.business.newsletter,
  country: (state: any) => state.business.country_code,
  whatsNumber: (state: any) => state.business?.whatsapp_phone ?? '',
  policies: (state: any) => state.business?.policies ?? [],
  enableWallet: (state: any) => state.business.enable_wallet,
  disableOTP: (state: any) => state.business?.disable_otp ?? false,
  show_login_button: (state: any) => state.business?.menu_layout?.show_login_button ?? true,
  default_cash: (state: any) => state.business?.default_cash ?? false,
  enabled_detailed_address: (state: any) => state.business?.enabled_detailed_address ?? false,
  detailed_address: (state: any) => state.business?.detailed_address ?? '',
}
